import { SVGProps, Ref, forwardRef } from 'react';

export const AntennaOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.184 3.73c1.737.075 2.397 1.21 2.475 2.414l.008.249c0 1.163-.508 2.327-1.967 2.604V15.5H7.3V8.996c-1.458-.277-1.966-1.44-1.966-2.603l.008-.25C5.422 4.9 6.125 3.728 8 3.728zM8 5.126c-.662 0-.904.205-1.008.33-.141.17-.258.479-.259.937 0 .458.118.767.26.937.103.125.344.33 1.007.33s.904-.205 1.008-.33c.141-.17.259-.48.259-.937 0-.459-.118-.767-.26-.937-.103-.125-.344-.33-1.007-.33"
                fill="currentColor"
            />
            <path
                d="M3.098 1.491a5 5 0 0 0-.273.299C1.851 2.96 1.4 4.602 1.4 6.394c0 1.791.45 3.433 1.425 4.603q.128.152.272.298l-.99.99C.596 10.751 0 8.572 0 6.393l.006-.375C.07 3.965.68 1.945 2.106.5z"
                fill="currentColor"
            />
            <path
                d="M13.89.501c1.427 1.445 2.039 3.464 2.104 5.518l.006.375c0 2.18-.597 4.358-2.11 5.89l-.989-.99q.145-.145.274-.297c.974-1.17 1.425-2.812 1.425-4.603 0-1.792-.45-3.434-1.425-4.604a5 5 0 0 0-.274-.3z"
                fill="currentColor"
            />
            <path
                d="M5.062 3.454a3 3 0 0 0-.154.169c-.558.67-.842 1.645-.842 2.77s.284 2.101.842 2.771q.071.085.153.167l-.99.99C3.063 9.298 2.666 7.846 2.666 6.393l.004-.25c.043-1.37.45-2.717 1.4-3.68z"
                fill="currentColor"
            />
            <path
                d="M11.928 2.464c1.008 1.022 1.405 2.476 1.405 3.93 0 1.453-.398 2.905-1.406 3.926l-.99-.989q.082-.082.154-.167c.558-.67.842-1.645.842-2.77s-.284-2.101-.842-2.771a3 3 0 0 0-.154-.168z"
                fill="currentColor"
            />
        </g>
    </svg>
));
AntennaOutlinedSize16Glyph.displayName = 'AntennaOutlinedSize16Glyph';
